import { RuleModel } from '../../../../types';
import SharedDialog from '../../../shared/shared-dialog';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface EditRuleDialogProps {
  open: boolean;
  handleClose: () => void;
  onEditExisting: () => void;
  onCreateNew: () => void;
  rule: RuleModel;
}

export default function EditRuleDialog({
  open,
  handleClose,
  onEditExisting,
  onCreateNew,
  rule,
}: EditRuleDialogProps) {
  const isEnabled = rule.basicInfo.status === 'Enabled';

  return (
    <SharedDialog
      open={open}
      handleClose={handleClose}
      title="Edit this rule or create a new one?"
      noCancel
      dialogContent={
        <Box>
          <Typography sx={{ mt: 1 }}>
            {isEnabled
              ? 'This rule is currently enabled.'
              : 'This rule is currently disabled.'}{' '}
            Would you like to modify the existing settings, or use them as a
            template for a new rule?
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ mt: 2, display: 'block' }}
          >
            Note: Any simulation data will include history from the original
            rule. If you want a clean slate, we recommend creating a new rule
            instead.
          </Typography>
        </Box>
      }
      primaryButton={{
        title: 'Create New Rule (Recommended)',
        action: onCreateNew,
        loading: false,
        disabled: false,
      }}
      secondaryButton={{
        title: 'Edit Existing',
        action: onEditExisting,
        loading: false,
        disabled: false,
      }}
    />
  );
}
